import {
  CreateSupplementalQuestionRequest,
  DeleteSupplementalQuestionRequest,
  ListSupplementalQuestionsRequest,
  ListSupplementalQuestionsResponse,
  SupplementalQuestion,
  UpdateSupplementalQuestionRequest,
  UpdateSupplementalQuestionsOrderRequest,
} from "../types/supplementalQuestions";
import { getOrganizationBaseUrl } from "../utils";
import { api } from "./axios";

export const listSupplementalQuestions = async ({
  organizationId,
}: ListSupplementalQuestionsRequest) => {
  const { data } = await api.get<ListSupplementalQuestionsResponse>(
    `${getOrganizationBaseUrl(organizationId)}/supplemental-forms`,
  );
  return data;
};

export const updateSupplementalQuestionsOrder = async ({
  consultationType,
  organizationId,
  questionIds,
}: UpdateSupplementalQuestionsOrderRequest) => {
  const { data } = await api.put<ListSupplementalQuestionsResponse>(
    `${getOrganizationBaseUrl(
      organizationId,
    )}/supplemental-forms/${consultationType}`,
    { question_ids: questionIds },
  );
  return data;
};

export const createSupplementalQuestion = async ({
  consultationType,
  organizationId,
  text,
  type,
  choices,
}: CreateSupplementalQuestionRequest) => {
  const { data } = await api.post<SupplementalQuestion>(
    `${getOrganizationBaseUrl(
      organizationId,
    )}/supplemental-forms/${consultationType}/questions`,
    { text, type, choices },
  );
  return data;
};

export const updateSupplementalQuestion = async ({
  consultationType,
  organizationId,
  id,
  text,
  type,
  choices,
}: UpdateSupplementalQuestionRequest) => {
  const { data } = await api.put<SupplementalQuestion>(
    `${getOrganizationBaseUrl(
      organizationId,
    )}/supplemental-forms/${consultationType}/questions/${id}`,
    { text, type, choices },
  );
  return data;
};

export const deleteSupplementalQuestion = async ({
  questionId,
  organizationId,
  consultationType,
}: DeleteSupplementalQuestionRequest) => {
  const { data } = await api.delete<null>(
    `${getOrganizationBaseUrl(
      organizationId,
    )}/supplemental-forms/${consultationType}/questions/${questionId}`,
  );
  return data;
};
